import { Checkbox } from "@chakra-ui/react";
import { colors, HStack, VStack, ColorIcon, NextLink } from "goi_common";
import { Dispatch, SetStateAction } from "react";

interface ConsultPrivacyAgreementProps {
  privateAgree: boolean;
  setPrivateAgree: Dispatch<SetStateAction<boolean>>;
  marketingAgree: boolean;
  setMarketingAgree: Dispatch<SetStateAction<boolean>>;
  isDropdownOpen: boolean;
  setIsDropdownOpen: Dispatch<SetStateAction<boolean>>;
  mainColor?: string;
}

export default function ConsultPrivacyAgreement({
  privateAgree,
  setPrivateAgree,
  marketingAgree,
  setMarketingAgree,
  isDropdownOpen,
  setIsDropdownOpen,
  mainColor = colors.orange650,
}: ConsultPrivacyAgreementProps) {
  return (
    <VStack width="100%" gap="8px" alignItems="flex-start" padding="0 4px">
      <HStack
        alignItems="center"
        gap="2px"
        width="100%"
        justifyContent="space-between"
      >
        <Checkbox
          isChecked={privateAgree && marketingAgree}
          onChange={(e) => {
            const checked = e.target.checked;
            setPrivateAgree(checked);
            setMarketingAgree(checked);
          }}
          size="md"
          sx={{
            ".chakra-checkbox__control": {
              bg: "gray.100",
              borderColor: "gray.300",
              _checked: {
                bg: mainColor,
                borderColor: mainColor,
              },
            },
            ".chakra-checkbox__label": {
              fontSize: "14px",
            },
          }}
        >
          전체 동의
        </Checkbox>
      </HStack>
      <VStack gap="8px" width="100%" css={{ paddingLeft: "18px" }}>
        <HStack
          alignItems="center"
          gap="2px"
          width="100%"
          justifyContent="space-between"
        >
          <Checkbox
            isChecked={privateAgree}
            onChange={(e) => {
              setPrivateAgree(e.target.checked);
            }}
            size="md"
            sx={{
              ".chakra-checkbox__control": {
                bg: "gray.100",
                borderColor: "gray.300",
                _checked: {
                  bg: mainColor,
                  borderColor: mainColor,
                },
              },
              ".chakra-checkbox__label": {
                fontSize: "14px",
              },
            }}
          >
            개인정보 수집 및 이용 동의 (필수)
          </Checkbox>
          <NextLink href="https://goifuneral.notion.site/f6e4472bcfd548d6bd5ac672fd84db27">
            <ColorIcon
              name="icon-arrow-right-small-mono"
              size={12}
              color={colors.gray700}
            />
          </NextLink>
        </HStack>
        <HStack
          alignItems="center"
          gap="2px"
          width="100%"
          justifyContent="space-between"
        >
          <Checkbox
            isChecked={marketingAgree}
            onChange={(e) => {
              setMarketingAgree(e.target.checked);
            }}
            size="md"
            sx={{
              ".chakra-checkbox__control": {
                bg: "gray.100",
                borderColor: "gray.300",
                _checked: {
                  bg: mainColor,
                  borderColor: mainColor,
                },
              },
              ".chakra-checkbox__label": {
                fontSize: "14px",
              },
            }}
          >
            마케팅 정보 수신 동의 (선택)
          </Checkbox>
          <NextLink href="https://goifuneral.notion.site/3d74caff865d48ccbf32d9a0ad3df80b">
            <ColorIcon
              name="icon-arrow-right-small-mono"
              size={12}
              color={colors.gray700}
            />
          </NextLink>
        </HStack>
      </VStack>
    </VStack>
  );
}
